import { PdfOutputDto } from '../../../lib/graphql'

export const downloadPdfs = async (
  pdfs: Pick<PdfOutputDto, 'filename' | 'url'>[],
) => {
  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)

  await Promise.all(
    pdfs.map(async ({ url, filename }, index) => {
      //setTimeout is necessary to download multiple files
      setTimeout(() => {
        if (!url) {
          return
        }
        if (isChrome) {
          const link = document.createElement('a')

          link.href = url
          link.download = filename

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          window.open(url)
        }
      }, 300 * index)
    }),
  )
}
